module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-container"
  }, [_c('div', {
    staticClass: "slider-wrapper",
    style: (_vm.styleobj),
    on: {
      "touchmove": _vm.swipeMove,
      "touchstart": _vm.swipeStart,
      "touchend": _vm.swipeEnd,
      "mousedown": _vm.swipeStart,
      "mouseup": _vm.swipeEnd,
      "mousemove": _vm.swipeMove
    }
  }, _vm._l((_vm.pages), function(list) {
    return _c('div', {
      staticClass: "slider-item"
    }, _vm._l((list), function(item) {
      return _c('a', {
        class: list.length == 1 ? 'single' : '',
        attrs: {
          "href": item.href
        }
      }, [_c('h4', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [(item.objectType == 1 || item.objectType == 3) ? _c('span', {
        staticClass: "star",
        class: 'star-' + item.star
      }) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_vm._v(_vm._s(item.price ? item.price : ''))]), _vm._v(" "), (item.objectType == 2 || item.objectType == 7) ? _c('span', [_vm._v(_vm._s(item.labelFirst))]) : _vm._e(), _vm._v(" "), (item.showType == 2 || item.showType == 5 || item.showType == 3) ? _c('span', [_vm._v(_vm._s(item.labelSecond))]) : _vm._e()])])
    }))
  })), _vm._v(" "), (_vm.pagenums > 1) ? _c('div', {
    staticClass: "slider-pagination"
  }, [_vm._l((_vm.pagenums), function(n) {
    return [_c('span', {
      class: n - 1 === _vm.sliderinit.currentPage ? 'on' : '',
      on: {
        "click": function($event) {
          _vm.slide(n - 1)
        }
      }
    })]
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-467213bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slide.vue
// module id = 610
// module chunks = 10